import LoadingSpinner from './loadingSpinner.vue';

/**
 * The loading spinner plugin exposes the following functions
 * - $hideGlobalLoadingSpinner: hides the loading spinner
 * - $showGlobalLoadingSpinner: shows the loading spinner
 */
export default {
  install(Vue, options) {
    // provide a global loading spinner component
    Vue.component(LoadingSpinner.name, LoadingSpinner);

    // define properties to be used by the plugin component itself
    Vue.prototype.$loadingSpinner = {
      componentCallback: undefined,
      loggingFn: () => {
        /* do nothing */
      },
      pendingTimeout: 0
    };

    if (options && options.loggingFn) {
      Vue.prototype.$loadingSpinner.loggingFn = options.loggingFn;
    }

    Vue.prototype.$hideGlobalLoadingSpinner = () => {
      Vue.prototype.$loadingSpinner.loggingFn('LoadingSpinnerPlugin::$hideGlobalLoadingSpinner()');

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.classList.remove('noscroll');

      const callback = Vue.prototype.$loadingSpinner.componentCallback;
      if (callback && typeof callback === 'function') {
        if (Vue.prototype.$loadingSpinner.pendingTimeout) {
          clearTimeout(Vue.prototype.$loadingSpinner.pendingTimeout);
          Vue.prototype.$loadingSpinner.pendingTimeout = 0;
        }

        callback(false);
      }
    };

    /**
     * Show the loading spinner. If a delay is given, the loading spinner shall
     * be shown only after the given amount of time in ms.
     *
     * This delay can come in handy, if the loading spinner might be only shown
     * for a fraction of a second and should not be shown to the user at all.
     */
    Vue.prototype.$showGlobalLoadingSpinner = (delay = 0) => {
      Vue.prototype.$loadingSpinner.loggingFn('LoadingSpinnerPlugin::$showGlobalLoadingSpinner()');

      if (document.body.clientHeight > window.innerHeight) {
        document.body.classList.add('noscroll');
      }

      const callback = Vue.prototype.$loadingSpinner.componentCallback;
      if (callback && typeof callback === 'function') {
        Vue.prototype.$loadingSpinner.pendingTimeout = setTimeout(() => {
          callback(true);
        }, delay);
      }
    };
  }
};
